export default {
  data () {
    return {
      io: null,
      pageSection: 0,
      ioSection: null,
      onDebounceHandler: null
    }
  },
  mounted () {
    // this.init()
    // TODO: component를 찾지 못하는 문제 해결 필요
    setTimeout(this.init, 300)

    this.$root.$on('router:change', () => {
      this.onGoSticky(null, this)
    })
  },
  beforeDestroy () {
    this.removeObserver()
  },
  watch: {
    '$route.params.child' () {
      this.removeObserver()
      this.initSectionObserver()
    }
  },
  methods: {
    init () {
      this.setIntersectionObserver()
      this.initSectionObserver()
      this.onScrollStart()
      this.onScrollEnd()

      if (this.$route.hash) {
        setTimeout(() => {
          document.documentElement.scrollTop = document.querySelector(`[data-id="${decodeURI(
                  this.$route.hash.replace('#', ''))}"]`).offsetTop - 150
        }, 300)
      } else {
        this.onGoSticky(null, this)
      }
    },
    setIntersectionObserver () {
      const options = {
        // root: document.querySelector('.root'), // .container class를 가진 엘리먼트를 root로 설정. null일 경우 브라우저 viewport
        // rootMargin: '0', // rootMargin을 '10px 10px 10px 10px'로 설정
        // threshold: [0, 0.5, 1] // 타겟 엘리먼트가 교차영역에 진입했을 때, 교차영역에 타켓 엘리먼트의 50%가 있을 때, 교차 영역에 타켓 엘리먼트의 100%가 있을 때 observe가 반응한다.
      }

      this.io = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // console.log('Enter - ', entry.target.id)
            if (this.$route.params.child !== entry.target.id) {
              this.$router.replace({
                params: {
                  child: entry.target.id
                }
              }).catch(e => {
              })

              this.onTabPositionCenter()
              // window.location.hash = this.tabList[v].hash
            }
            return
          }

          if (entry.boundingClientRect.top > 0) {
            // console.log('BELOW - ', entry.target.id)
          } else {
            // console.log('ABOVE - ', entry.target.id)
          }
          // console.log('entry:', entry.boundingClientRect.top > 0, entry.boundingClientRect.top)
        })
      }, options)
    },
    onScrollStart () {
      const sticky = document.querySelectorAll('.sticky')
      sticky.forEach((el) => {
        this.io.observe(el)
      })
    },
    onScrollEnd () {
      function waitForScrollEnd () {
        let lastChangedFrame = 0
        let lastX = window.scrollX
        let lastY = window.scrollY

        return new Promise(resolve => {
          function tick (frames) {
            if (frames >= 500 || frames - lastChangedFrame > 20) {
              resolve()
            } else {
              if (window.scrollX !== lastX || window.scrollY !== lastY) {
                lastChangedFrame = frames
                lastX = window.scrollX
                lastY = window.scrollY
              }
              requestAnimationFrame(tick.bind(null, frames + 1))
            }
          }

          tick(0)
        })
      }

      let scrollStart = 0
      window.addEventListener('scroll', () => {
        scrollStart = 0
        waitForScrollEnd().then(() => {
          scrollStart++
          if (scrollStart === 1) {
            // Scroll end
            this.onScrollStart()
          }
        })

        const showingTabList = [].filter.call(
            document.querySelectorAll('.tab-wrap'), item => {
              const offsetTop = item.offsetTop -
                  document.documentElement.scrollTop

              return offsetTop >= 0 && offsetTop <=
                  document.documentElement.clientHeight
            })

        if (showingTabList.length > 1) {
          showingTabList[0].style.opacity = 0
        } else if (showingTabList.length === 1) {
          showingTabList[0].style.opacity = 1
        }
      })
    },
    onGoSticky (e, vm) {
      if (this.io) {
        const spy = document.querySelectorAll('.sticky')
        spy.forEach((el) => {
          this.io.disconnect(el)
        })
      }

      if (vm.$route.params && vm.$route.params.child) {
        const header = document.querySelector('.header')
        const child = document.getElementById(vm.$route.params.child)

        if (child) {
          const currentTab = child.parentNode.querySelector('.tab-wrap')
          const offset = currentTab.offsetHeight + 80

          currentTab.dataset.noAnimate = 'true'

          document.documentElement.scrollTop = child &&
              (child.offsetTop - offset)
          setTimeout(() => {
            header.classList.add('header-hide')
            delete currentTab.dataset.noAnimate
          }, 600)
        }
      }
    },
    onGoAnchor () {
      setTimeout(() => {
        document.querySelector('.header').classList.add('header-hide')
      }, 100)
    },
    onSectionObserver (entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const elem = entry.target

          document.querySelectorAll('[data-id]').forEach(item => {
            const anchor = document.querySelector(`a[href="#${item.dataset.id}"]`)

            if (anchor) {
              if (item.dataset.id === elem.dataset.id) {
                anchor.classList.add('active')
                anchor.parentElement.scrollLeft = anchor.offsetLeft - 22 // - (anchor.parentElement.offsetWidth / 2)
              } else {
                anchor.classList.remove('active')
              }
            }
          })
        }
      })
    },
    setSectionObserver () {
      this.ioSection = new IntersectionObserver(this.onSectionObserver, {
        threshold: [0],
        rootMargin: '0px 0px 0px 0px'
      })
    },
    initSectionObserver () {
      this.setSectionObserver()
      document.querySelectorAll('[data-id]').forEach(v => {
        this.ioSection.observe(v)
      })
    },
    removeObserver () {
      if (this.ioSection) {
        this.ioSection.disconnect()
        this.ioSection = null
      }
    },
    onTabPositionCenter () {
      const tabs = document.querySelectorAll('.tab-scroll')

      Array.from(tabs).forEach(tab => {
        const currentTab = tab.querySelector('.active')
          tab.scrollLeft = currentTab.offsetLeft - (tab.offsetWidth / 2)
      })
    }
  }
}
